import React from 'react'
import {NavLink} from 'react-router-dom'

interface KwotaLogoProps {
  url: string;
  className?: string;
}

/**
 * LOGO SVG. Should be imported instead.
 * Pass height through className in order to use.
 */

const KwotaLogo = ({url, className}: KwotaLogoProps) => {
  return (
    <NavLink to={url} className={className}>
      <svg height="100%" viewBox="0 0 114 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.06997 15.8621V23.5517H0V0.448276H8.06997V8.62069H9.46134L12.0702 0.448276H20.0706L16.3486 11.6207L20.4184 23.5517H12.3137L9.49613 15.8621H8.06997Z" fill="#009FDD" />
        <path d="M23.1098 23.5517L20.3619 0.448276H28.3971L29.5102 15.4828H30.1363L31.7016 0.793104H40.502L42.2412 15.4828H42.8674L43.563 0.448276H51.6678L49.0938 23.5517H37.3019L36.154 9.34483L35.8061 9.31034L34.6235 23.5517H23.1098Z" fill="#009FDD" />
        <path d="M60.4065 12C60.4065 13.954 60.5921 15.3678 60.9631 16.2414C61.3573 17.092 62.1574 17.5172 63.3632 17.5172C64.5923 17.5172 65.3923 17.092 65.7633 16.2414C66.1344 15.3908 66.3199 13.977 66.3199 12C66.3199 10 66.1344 8.58621 65.7633 7.75862C65.4155 6.90804 64.627 6.48276 63.398 6.48276C62.1689 6.48276 61.3573 6.91954 60.9631 7.7931C60.5921 8.64368 60.4065 10.046 60.4065 12ZM74.4594 12C74.4594 16.2069 73.5782 19.2644 71.8158 21.1724C70.0534 23.0575 67.2359 24 63.3632 24C59.5137 24 56.6962 23.046 54.9106 21.1379C53.1482 19.2299 52.267 16.1839 52.267 12C52.267 7.7931 53.1482 4.74713 54.9106 2.86207C56.673 0.954022 59.4906 0 63.3632 0C67.2359 0 70.0534 0.954022 71.8158 2.86207C73.5782 4.74713 74.4594 7.7931 74.4594 12Z" fill="#009FDD" />
        <path d="M74.9187 6.96552V0.448276H92.3109V6.96552H87.7889V23.5517H79.7189V6.96552H74.9187Z" fill="#009FDD" />
        <path d="M90.533 23.5517L95.6811 0.448276H107.89L113.143 23.5517H105.003L104.342 20.8966H99.0204L98.4639 23.5517H90.533ZM101.386 6.72414L100.064 14.7931H103.508L102.255 6.72414H101.386Z" fill="#009FDD" />
      </svg>
    </NavLink>
  )
}

export default KwotaLogo
